import findIndex from 'lodash/findIndex';
import { handleActions } from 'redux-actions';
import { emptyMetaConversation } from '../../../conversation/reducers/conversation';
import { transferToAgentActions } from '../actions/transferToAgentModal';
export const initialState = {
    meta: {
        requestAssistedTransfer: 'succeeded',
        requestBlindTransfer: 'succeeded',
    },
    ui: {
        isModalShown: false,
        isMessageModalShown: false,
    },
    metaConversation: emptyMetaConversation(),
    transferRequests: [],
};
export const { transferToAgentAssistedRequest, transferToAgentAssistedRequestSucceeded, transferToAgentAssistedRequestFailed, transferToAgentBlindRequest, transferToAgentBlindRequestSucceeded, transferToAgentBlindRequestFailed, transferToAgentAssistedResolve, transferToAgentAssistedResolveSucceeded, transferToAgentAssistedResolveFailed, transferToAgentModalOpen, transferToAgentModalClose, transferToAgentRequestStop, transferToAgentShowMessageModal, transferToAgentHideMessageModal, 
// WS actions.
transferToAgentWsResponse, transferToAgentWsTransferStarted, transferToAgentWsTransferAnswered, } = transferToAgentActions;
const transferToAgent = handleActions({
    [transferToAgentShowMessageModal.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { ui: Object.assign(Object.assign({}, state.ui), { isMessageModalShown: true }) });
    },
    [transferToAgentHideMessageModal.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { ui: Object.assign(Object.assign({}, state.ui), { isMessageModalShown: false }) });
    },
    // Show transfer to agent modal.
    [transferToAgentModalOpen.toString()]: (state, action) => {
        const metaConversation = Object.assign({}, action.payload.metaConversation);
        return Object.assign(Object.assign({}, state), { ui: Object.assign(Object.assign({}, state.ui), { isModalShown: true }), metaConversation: metaConversation });
    },
    // Hide transfer to agent modal.
    [transferToAgentModalClose.toString()]: (state, action) => {
        return Object.assign(Object.assign({}, state), { ui: Object.assign(Object.assign({}, state.ui), { isModalShown: false }), users: [] });
    },
    [transferToAgentAssistedRequest.toString()]: (state, action) => {
        const metaConversation = Object.assign({}, action.payload.metaConversation);
        const requestToUser = Object.assign({}, action.payload.requestToUser);
        const requestFromAgent = Object.assign({}, action.payload.requestFromAgent);
        const request = {
            metaConversation: metaConversation,
            requestToUser: requestToUser,
            requestFromAgent: requestFromAgent,
        };
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { requestAssistedTransfer: 'loading' }), transferRequests: [
                request,
                ...state.transferRequests.filter((t) => t.metaConversation.conversation.id !==
                    metaConversation.conversation.id),
            ] });
    },
    // We do not remove metaConversation here,
    // we need to wait until transferTAgentAssistedResolveSucceeded/Failed.
    // or transferToAgentAssistedRequestFailed
    [transferToAgentAssistedRequestSucceeded.toString()]: (state) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { requestAssistedTransfer: 'succeeded' }), ui: Object.assign(Object.assign({}, state.ui), { isModalShown: false }), users: [] });
    },
    // The transfer to agent request failed.
    // It does not make sense to keep the metaConversation in the store.
    [transferToAgentAssistedRequestFailed.toString()]: (state, action) => {
        const { metaConversation } = action.payload.action;
        const index = findIndex(state.transferRequests, (assistedTransferRequest) => {
            var _a;
            return (metaConversation !== undefined &&
                ((_a = assistedTransferRequest === null || assistedTransferRequest === void 0 ? void 0 : assistedTransferRequest.metaConversation) === null || _a === void 0 ? void 0 : _a.conversation.id) ===
                    metaConversation.conversation.id);
        });
        if (index > -1) {
            const transferRequests = state.transferRequests.slice();
            transferRequests.splice(index, 1);
            return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { requestAssistedTransfer: 'failed' }), transferRequests: transferRequests, metaConversation: emptyMetaConversation() });
        }
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { requestAssistedTransfer: 'failed' }), metaConversation: emptyMetaConversation() });
    },
    [transferToAgentBlindRequest.toString()]: (state, action) => {
        const metaConversation = Object.assign({}, action.payload.metaConversation);
        const requestToUser = Object.assign({}, action.payload.requestToUser);
        const requestFromAgent = Object.assign({}, action.payload.requestFromAgent);
        const request = {
            metaConversation: metaConversation,
            requestToUser: requestToUser,
            requestFromAgent: requestFromAgent,
        };
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { requestBlindTransfer: 'loading' }), transferRequests: [
                request,
                ...state.transferRequests.filter((t) => t.metaConversation.conversation.id !==
                    metaConversation.conversation.id),
            ] });
    },
    // We do not remove the metaConversation yet.
    [transferToAgentBlindRequestSucceeded.toString()]: (state, action) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { requestBlindTransfer: 'succeeded' }), ui: Object.assign(Object.assign({}, state.ui), { isModalShown: false }), users: [] });
    },
    [transferToAgentBlindRequestFailed.toString()]: (state, action) => {
        const { metaConversation } = action.payload.action;
        const index = findIndex(state.transferRequests, (blindTransferRequest) => {
            var _a, _b;
            return (metaConversation !== undefined &&
                ((_b = (_a = blindTransferRequest === null || blindTransferRequest === void 0 ? void 0 : blindTransferRequest.metaConversation) === null || _a === void 0 ? void 0 : _a.conversation) === null || _b === void 0 ? void 0 : _b.id) ===
                    metaConversation.conversation.id);
        });
        if (index > -1) {
            const transferRequests = state.transferRequests.slice();
            transferRequests.splice(index, 1);
            return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { requestBlindTransfer: 'failed' }), transferRequests: transferRequests });
        }
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { requestAssistedTransfer: 'failed' }) });
    },
    [transferToAgentAssistedResolve.toString()]: (state, action) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { requestAssistedTransfer: 'loading' }) });
    },
    // The transfer to agent was resolved.
    // We cleanup the store (by removing the metaConversation).
    [transferToAgentAssistedResolveSucceeded.toString()]: (state, action) => {
        const csid = action.payload.data.csid;
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { requestAssistedTransfer: 'succeeded' }), transferRequests: [
                ...state.transferRequests.filter((t) => t.metaConversation.conversation.id !== csid),
            ], metaConversation: emptyMetaConversation() });
    },
    [transferToAgentAssistedResolveFailed.toString()]: (state, action) => {
        return Object.assign(Object.assign({}, state), { meta: Object.assign(Object.assign({}, state.meta), { requestAssistedTransfer: 'failed' }) });
    },
    // The transfer to agent request was stop (maybe because the conversation was closed/claimed).
    // We remove the metaConversation from the store and closes the transfer modal.
    [transferToAgentRequestStop.toString()]: (state, action) => {
        const { csid } = action.payload;
        const transferRequests = state.transferRequests.slice();
        const index = findIndex(state.transferRequests, (request) => {
            var _a;
            return ((_a = request.metaConversation) === null || _a === void 0 ? void 0 : _a.conversation.id) === csid;
        });
        if (index > -1) {
            transferRequests.splice(index, 1);
            return Object.assign(Object.assign({}, state), { transferRequests: transferRequests, metaConversation: emptyMetaConversation() });
        }
        return Object.assign(Object.assign({}, state), { ui: Object.assign(Object.assign({}, state.ui), { isModalShown: false }), users: [], metaConversation: emptyMetaConversation() });
    },
    [transferToAgentWsResponse.toString()]: (state, action) => {
        const { csid, accepted } = action.payload;
        const transferRequests = state.transferRequests.slice();
        const index = findIndex(state.transferRequests, (request) => {
            var _a;
            return (((_a = request.metaConversation) === null || _a === void 0 ? void 0 : _a.conversation.id) === csid &&
                (accepted === true || accepted === false));
        });
        const ui = Object.assign({}, state.ui);
        // If the modal is open and the transfer is completed
        if (ui.isModalShown === true &&
            (accepted === true || accepted === false) &&
            csid === state.metaConversation.conversation.id) {
            ui.isModalShown = false;
        }
        if (index > -1) {
            transferRequests.splice(index, 1);
            return Object.assign(Object.assign({}, state), { ui: ui, transferRequests: transferRequests, metaConversation: emptyMetaConversation() });
        }
        return Object.assign(Object.assign({}, state), { ui: ui });
    },
}, initialState);
export default transferToAgent;
